import { render, staticRenderFns } from "./EditAllergy.vue?vue&type=template&id=29c8f396&scoped=true"
import script from "./EditAllergy.vue?vue&type=script&lang=js"
export * from "./EditAllergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8f396",
  null
  
)

export default component.exports